import { useCallback, useMemo, useState } from "react";
import { useIsInSMSize } from "sketon/utility/DeviceInfo";
import styled from "styled-components";
import { BSSize } from "../Size";
import SpaceHolder from "../Space";

const StyledIcon = styled.img<{
  iconSize: BSSize;
  display: string;
  topSpace: string;
}>`
  display: ${({ display }) => display};
  width: ${({ iconSize }) => iconSize.w}rem;
  height: ${({ iconSize }) => iconSize.h}rem;
  margin-top: ${({ topSpace }) => topSpace};
`;

const StyledTitle = styled.span<{
  space?: string;
  fontSize: string;
  lineHeight: string;
  color?: string;
  fontWeight: string;
  width?: string;
  hocolor?: string;
  accolor?: string;
  rightSpace?: string;
  fontFamily?: string;
  fontStyle: string;
}>`
  /* width: 100px; */
  margin-left: ${({ space }) => space};
  margin-right: ${({ rightSpace }) => rightSpace};
  font-size: ${({ fontSize }) => fontSize};
  color: ${({ color }) => color};
  line-height: ${({ lineHeight }) => lineHeight};
  text-align: left;
  font-weight: ${({ fontWeight }) => fontWeight};
  font-family: ${({ fontFamily }) => fontFamily};
  width: ${({ width }) => (width !== undefined ? width : "100%")};
  word-break: break-all;
  text-overflow: ellipsis;
  /* :hover {
    color: ${({ hocolor }) => hocolor};
  }
  :active {
    color: ${({ accolor }) => accolor};
  } */

  font-style: ${({ fontStyle }) => fontStyle};
`;
const StyledWraper = styled.div<{
  h: string;
  flex: string;
  alignItem: string;
  padding: string;
  bg: string;
  borderRadius: string;
  supportScale: boolean;
  width: string;
  border: string;
}>`
  width: ${({ width }) => width};
  height: ${({ h }) => h};
  margin-top: 0;
  margin-left: 0;
  padding: ${({ padding }) => padding};
  border-radius: ${({ borderRadius }) => borderRadius};
  background: ${({ bg }) => bg};

  display: flex;
  flex-flow: row;
  justify-content: ${({ flex }) => flex};
  align-items: ${({ alignItem }) => alignItem};

  transition: 0.2s;

  :active {
    transform: scale(${({ supportScale }) => (supportScale ? 0.95 : 1.0)});
  }

  border: ${({ border }) => border};
`;

export enum BSIconTextLayoutMode {
  ICON_LEFT,
  ICON_RIGHT,
}

interface BSIconTextProps {
  icon?: string;
  hoIcon?: string;
  acIcon?: string;
  iconSize: BSSize;
  space?: string;
  rightSpace?: string;

  fontSize: string;
  lineHeight: string;
  color?: string;
  text: string;

  layoutMode?: BSIconTextLayoutMode;
  flex?: string;
  width?: string;
  background?: string;
  hoBackground?: string;
  hocolor?: string;
  accolor?: string;
  height?: string;
  id?: string;

  alignItem?: string;
  iconTopSpace?: string;
  iconClick?: () => void;
  click?: () => void;
  padding?: string;
  borderRadius?: string;
  supportScale?: boolean;
  btnWidth?: string;
  border?: string;
  hoBorder?: string;
  fontFamily?: string;
  isBold: boolean;
  fontStyle?: string;
}

export const BSIconText: React.FC<BSIconTextProps> = ({
  icon,
  hoIcon,
  acIcon,
  iconSize,
  space = "0",
  fontSize,
  lineHeight,
  color,
  text,
  layoutMode = BSIconTextLayoutMode.ICON_LEFT,
  flex = "flex-start",
  width,
  background = "transparent",
  hoBackground = background,
  hocolor,
  accolor,
  height = lineHeight,
  id = "",
  alignItem = "center",
  iconTopSpace = "0px",
  rightSpace,
  iconClick,
  click,
  padding,
  borderRadius = "0px",
  supportScale = false,
  btnWidth = "100%",
  border = "",
  hoBorder = "",
  fontFamily,
  isBold,
  fontStyle = "normal",
}) => {
  const [isHover, setIsHover] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const isSMSize = useIsInSMSize();

  const getIcon = useCallback(() => {
    var ret = icon;
    if (isHover && !isActive) {
      if (hoIcon) {
        ret = hoIcon;
      }
    } else if (isActive) {
      if (acIcon) {
        ret = acIcon;
      }
    }

    return ret;
  }, [isHover, isActive, icon, hoIcon, acIcon]);

  const getColor = useCallback(() => {
    var ret = color;
    if (!isSMSize && isHover && !isActive) {
      if (hocolor) {
        ret = hocolor;
      }
    } else if (isActive) {
      if (accolor) {
        ret = accolor;
      }
    }

    return ret;
  }, [isHover, isActive, accolor, hocolor, color, isSMSize]);

  const getBG = useMemo(() => {
    var ret = background;
    if (!isSMSize) {
      if (isHover) {
        ret = hoBackground;
      }
    } else {
      ret = background;
    }

    return ret;
  }, [hoBackground, background, isHover, isSMSize]);

  const getBorder = useMemo(() => {
    var ret = border;
    if (!isSMSize) {
      if (isHover) {
        ret = hoBorder;
      }
    } else {
      ret = border;
    }

    return ret;
  }, [hoBorder, border, isHover, isSMSize]);

  return (
    <StyledWraper
      h={height}
      flex={flex}
      id={id}
      alignItem={alignItem}
      padding={padding ? padding : "0 0 0 0"}
      onMouseOver={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
      onMouseDown={() => setIsActive(true)}
      onMouseUp={() => setIsActive(false)}
      onClick={click ? click : () => {}}
      bg={getBG}
      borderRadius={borderRadius}
      supportScale={supportScale}
      width={btnWidth}
      border={getBorder}
    >
      {layoutMode === BSIconTextLayoutMode.ICON_LEFT && (
        <>
          <StyledIcon
            src={getIcon()}
            display={icon ? "block" : "none"}
            iconSize={iconSize}
            topSpace={iconTopSpace}
          ></StyledIcon>
          <StyledTitle
            width={width !== undefined ? width : "fit-content"}
            space={space}
            fontSize={fontSize}
            lineHeight={lineHeight}
            color={getColor()}
            fontWeight={isBold ? "bold" : "normal"}
            fontFamily={fontFamily}
            fontStyle={fontStyle}
            // hocolor={hocolor ? hocolor : color}
            // accolor={accolor ? accolor : color}
          >
            {text}
          </StyledTitle>
        </>
      )}

      {layoutMode === BSIconTextLayoutMode.ICON_RIGHT && (
        <>
          <StyledTitle
            width={width !== undefined ? width : "fit-content"}
            space={"0"}
            fontSize={fontSize}
            lineHeight={lineHeight}
            color={getColor()}
            fontWeight={isBold ? "bold" : "normal"}
            fontFamily={fontFamily}
            // hocolor={hocolor ? hocolor : color}
            // accolor={accolor ? accolor : color}
            rightSpace={rightSpace ? rightSpace : "0"}
            fontStyle={fontStyle}
          >
            {text}
          </StyledTitle>

          <SpaceHolder isVertical={false} value={space}></SpaceHolder>
          <StyledIcon
            src={getIcon()}
            display={icon ? "block" : "none"}
            iconSize={iconSize}
            topSpace={iconTopSpace}
            onClick={iconClick ? () => iconClick : () => {}}
          ></StyledIcon>
        </>
      )}
    </StyledWraper>
  );
};
